export default __webpack_public_path__ + "static/media/howitwork.cf895afb.svg";